export default __webpack_public_path__ + "static/media/G0750.34I-27930_-17361_0.1666265400000.9627d520.jpg";